import LanderBreadcrumb from "./LanderBreadcrumb";
import { useLanderLandingComponents } from "../hooks/useLanderLandingComponents";
import { useLightningLanderContext } from "../providers/LightningLanderProvider";

function LanderComponentBreadcrumb() {
  const { setComponents } = useLanderLandingComponents();
  const { component, setComponent } = useLightningLanderContext();

  if (!component) {
    return <></>;
  }

  return (
    <LanderBreadcrumb
      component={component}
      setComponent={setComponent}
      setComponents={setComponents}
    />
  );
}

export default LanderComponentBreadcrumb;
